import React from 'react';
import './Pagination.css';

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  // Số lượng trang lân cận sẽ hiển thị quanh trang hiện tại
  const siblingCount = 1;
  const DOTS = '...';

  // Tính toán các trang sẽ hiển thị
  const getPageNumbers = () => {
    const totalPageNumbers = siblingCount * 2 + 5; // 5 = first, last, current, 2 DOTS
    if (totalPages <= totalPageNumbers) {
      return Array.from({ length: totalPages }, (_, i) => i + 1);
    }
    const pages = [];
    const leftSibling = Math.max(currentPage - siblingCount, 1);
    const rightSibling = Math.min(currentPage + siblingCount, totalPages);
    const showLeftDots = leftSibling > 2;
    const showRightDots = rightSibling < totalPages - 1;

    if (!showLeftDots && showRightDots) {
      // Chỉ có ... bên phải
      for (let i = 1; i <= 3 + siblingCount * 2; i++) pages.push(i);
      pages.push(DOTS);
      pages.push(totalPages);
    } else if (showLeftDots && !showRightDots) {
      // Chỉ có ... bên trái
      pages.push(1);
      pages.push(DOTS);
      for (let i = totalPages - (2 + siblingCount * 2); i <= totalPages; i++) pages.push(i);
    } else if (showLeftDots && showRightDots) {
      // Có ... cả hai bên
      pages.push(1);
      pages.push(DOTS);
      for (let i = leftSibling; i <= rightSibling; i++) pages.push(i);
      pages.push(DOTS);
      pages.push(totalPages);
    }
    return pages;
  };

  const pageNumbers = getPageNumbers();

  if (totalPages <= 1) return null;

  return (
    <nav>
      <ul className="pagination">
        {/* Nút Previous */}
        <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
          <button
            className="page-link"
            onClick={() => onPageChange(currentPage - 1)}
            disabled={currentPage === 1}
          >
            Trước
          </button>
        </li>
        {/* Danh sách các số trang và ... */}
        {pageNumbers.map((number, idx) =>
          number === DOTS ? (
            <li key={idx} className="page-item disabled">
              <button className="page-link">...</button>
            </li>
          ) : (
            <li key={number} className={`page-item ${currentPage === number ? 'active' : ''}`}>
              <button
                className="page-link"
                onClick={() => onPageChange(number)}
              >
                {number}
              </button>
            </li>
          )
        )}
        {/* Nút Next */}
        <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
          <button
            className="page-link"
            onClick={() => onPageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
          >
            Sau
          </button>
        </li>
      </ul>
    </nav>
  );
};

export default Pagination;